import actionTypes from '../constants/action-types';

const defaultState = null;

const single = (state = defaultState, action) => {
  switch (action.type) {
    case actionTypes.SET_SINGLE:
      return action.payload.template;

    case actionTypes.SET_DATA: {
      const results = action.payload.templatesData?.results || [];
      if (!results.length || !state) return state;
      // When a paginated batch arrives, remove single whose slug is now in results to avoid duplication
      const resultSlugs = new Set(results.map((template) => template.slug));
      if (resultSlugs.has(state.slug)) {
        return defaultState;
      }
      return state;
    }
    default:
      return state;
  }
};

export default single;
